module.exports = __webpack_public_path__ + "static/media/leptophyes_punctatissima_BD_001_APA.e8597e9f.mp3";